<dynamic-form
  *ngIf="formGroup"
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns"
  [erroremessage]="erroremessage"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <div class="fcContent row" style="max-width: 160vmin" *ngIf="formGroup">
    <div class="row col-sm-3 column">
      <tree-lookup
        class="col-sm-12"
        name="SellCustomerGroup"
        id="treelookupSellCustomerGroup"
        [group]="formGroup"
        label="گروه مشتری"
        apiName="SellCustomerGroup/ReadSellCustomerGroupLookUp"
        parentIdName="ParentId"
        textFieldName="TreePath"
        (onRowSelected)="onRowSelectedGroup($event)"
        valueFieldName="Id"
        [disabled]="false"
        systemName=""
        category=""
        textColumnsName=""
        [required]="false">
      </tree-lookup>
      <ssg-select
        class="col-sm-12"
        name="SellKind"
        [group]="formGroup"
        label="نوع فروش"
        apiName="SellKind/ReadLookUp"
        textFieldName="Title"
        (onRowSelected)="onRowSelected($event)"
        valueFieldName="Id">
      </ssg-select>
    </div>
    <div class="row col-sm-3 column">
      <div class="col-sm-12">
        <ssg-input name="UnitPrice" min="0" max="999999999999" [group]="formGroup" label="مبلغ فی"> </ssg-input>
      </div>
      <div class="col-sm-12 topmargin">
        <ssg-input name="DiscountRate" min="0" max="100" [group]="formGroup" label="درصد تخفیف"> </ssg-input>
      </div>
    </div>
    <div class="row col-sm-3 column">
      <div class="col-sm-12">
        <ssg-input name="UnitPriceratio" min="0" max="9999999999" [group]="formGroup" label="ضریب فی"> </ssg-input>
      </div>
      <div class="col-sm-12 topmargin">
        <ssg-radiobox
          name="averagePurchaseId"
          id="averagePurchaseId"
          [group]="formGroup"
          (valueChange)="onChange($event)"
          [items]="averagePurchase"
          textFieldName="Title"
          valueFieldName="Code">
        </ssg-radiobox>
      </div>
    </div>
    <div class="row col-sm-3 column">
      <div class="col-sm-12">
        <ssg-checkbox
          id="CheckAllUnit"
          [group]="formGroup"
          name="CheckAllUnit"
          (valueChange)="checkAllUnitValueChange($event)"
          label="انتخاب فی قطعی">
        </ssg-checkbox>
      </div>
      <div class="col-sm-12 topmargin">
        <ssg-checkbox
          id="CheckAllDiscount"
          [group]="formGroup"
          name="CheckAllDiscount"
          (valueChange)="checkAllDiscountValueChange($event)"
          label="انتخاب تخفیف">
        </ssg-checkbox>
      </div>
    </div>
  </div>
  <ng-container class="content" *ngIf="PriceListDetailList && PriceListDetailList.length > 0">
    <editable-grid
      #detail
      [columns]="PriceListDetailList"
      [dataList]="model.PriceListDetailList"
      [newdefaultRowTregger]="onNewdefaultRowTregger"
      [isAdd]="true"
      [noReduplicative]="true"
      [SelectById]="'GoodsId'"
      [isMulti]="true"
      (valueChanges)="valueChanges($event)"
      [isDelete]="true">
    </editable-grid>
  </ng-container>
  <ng-container class="footer">
    <ssg-button
      icon="fa fa-filter"
      buttontype="button"
      (click)="changeGroup()"
      class="login-btn"
      label="جایگزین گروه مشتری و نوع فروش"
      appearance="flat">
    </ssg-button>
    <ssg-button icon="fa fa-filter" buttontype="button" class="login-btn" (click)="replaceUnitPrice()" label="جایگزین فی" appearance="flat">
    </ssg-button>
    <ssg-button icon="fa fa-filter" buttontype="button" (click)="increaseUnitPrice()" label="افزایش فی" class="login-btn" appearance="flat">
    </ssg-button>
  </ng-container>
</dynamic-form>
